import { useQuery } from '@tanstack/react-query';
import { type ChainData } from '@/shared/assets/chains';
import { isChainflipTokenOrChain } from '@/shared/assets/tokens';
import { integrationManager } from '@/shared/integrations';
import { CHAINFLIP_BLOCK_CONFIRMATIONS } from '@/shared/queryKeys';

type ConfirmationData = {
  isLoading: boolean;
  requiredBlockConfirmations?: number | null;
};

const useChainflipBlockConfirmations = (chain: ChainData | undefined): ConfirmationData => {
  if (!isChainflipTokenOrChain(chain)) {
    return { requiredBlockConfirmations: null, isLoading: false };
  }

  const { data, isLoading } = useQuery({
    queryKey: [CHAINFLIP_BLOCK_CONFIRMATIONS, chain.chainflipId],
    queryFn: () =>
      integrationManager.getIntegration('chainflip').sdk.getRequiredBlockConfirmations(),
    select: (requiredConfirmations) => ({
      requiredBlockConfirmations: requiredConfirmations[chain.chainflipId],
    }),
  });

  return { ...data, isLoading };
};

export default useChainflipBlockConfirmations;
